import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { AuthShell } from "@/pages/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiError } from "@/lib/api";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };
  return (
    <AuthShell title="Reset password" subtitle="We'll email you a secure reset link."
      footer={<Link to="/login" className="font-semibold text-emerald-brand">Back to sign in</Link>}>
      {sent ? (
        <div className="bg-teal-50 border border-teal-200 rounded-xl p-5 text-teal-800" data-testid="forgot-sent">
          If that email is registered, a reset link has been sent. Please check your inbox.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label className="font-semibold text-slate-600">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="mt-1.5 h-11" placeholder="you@example.com" />
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="w-full bg-[#0B223D] text-white font-bold h-12 rounded-xl">
            {loading ? "Sending…" : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
